// method to update control panel display
const updateText = (ctx, bool, speaker, customText) => {
  customText = customText || ''
  if (bool) { // update text if slide is not blank
    ctx.activeText = ctx.text[ctx.currentSlideIndex]
    if (speaker) ctx.activeText.speaker = speaker
  } else {
    // set text to blank
    ctx.activeText = {
      string: customText,
      speaker: null
    }
    // inject blank placeholder into text array
    ctx.text = ctx.text.slice(0, ctx.currentSlideIndex)
      .concat(new Array(1))
      .concat(ctx.text.slice(ctx.currentSlideIndex))
  }
  ctx.currentSlideIndex += 1 // increment slide index
}

export {
  updateText
}

// todo: enable/disable control panel, change from bool to {options}



// WEBPACK FOOTER //
// ./src/assets/js/utils/updateText.js